// extracted by mini-css-extract-plugin
export default {"disableScrollbars":"TableSelect_disableScrollbars__Nk8rd","search":"TableSelect_search__h0Y5z"};